var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideocamOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "videocam_off"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1373_17593",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 96,
    height: 96
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 96,
    height: 96,
    fill: "#C0C7D1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1373_17593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "videocam_off_2",
    d: "M82.0482 63.4452L71.0637 52.4607V60.0454L29.0177 17.9994H63.8329C65.8535 17.9994 67.5637 18.6994 68.9637 20.0994C70.3637 21.4994 71.0637 23.2097 71.0637 25.2302V43.5379L82.0482 32.5534C82.638 31.9637 83.3008 31.8162 84.0366 32.1111C84.7725 32.406 85.1404 32.9688 85.1404 33.7995V62.1991C85.1404 63.0299 84.7725 63.5926 84.0366 63.8875C83.3008 64.1824 82.638 64.035 82.0482 63.4452ZM77.7713 86.5221L8.23323 16.9839C7.67936 16.4301 7.39603 15.734 7.38323 14.8955C7.37043 14.0571 7.65376 13.3482 8.23323 12.7687C8.81269 12.1892 9.51523 11.8994 10.3408 11.8994C11.1664 11.8994 11.869 12.1892 12.4484 12.7687L81.9866 82.3068C82.5404 82.8606 82.8238 83.5567 82.8366 84.3952C82.8494 85.2337 82.5661 85.9427 81.9866 86.5221C81.4072 87.1016 80.7046 87.3913 79.8789 87.3913C79.0533 87.3913 78.3508 87.1016 77.7713 86.5221ZM17.7562 18.0763L70.9867 71.3068C70.8585 73.1735 70.1137 74.7555 68.7521 76.0529C67.3906 77.3504 65.7509 77.9991 63.8329 77.9991H18.2947C16.2742 77.9991 14.5639 77.2991 13.1639 75.8991C11.7639 74.4991 11.0639 72.7889 11.0639 70.7683V25.2301C11.0639 23.3122 11.7127 21.6725 13.0101 20.3109C14.3075 18.9494 15.8896 18.2045 17.7562 18.0763Z",
    fill: "#A0AEC0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideocamOff);
export default __webpack_public_path__ + "static/media/videocam_off.9e8644b3a8ce6190afb5e7519899367f.svg";
export { ForwardRef as ReactComponent };